import { Injectable } from "@nestjs/common";
import { Assets } from "../../open-assets/open-assets-entity";
import { AssetAssignmentTransactionDto } from "../dto/asset-assignment-transaction.dto";
import { AssetAssignmentDto } from "../dto/asset-assignment.dto";
import { AssetAssignmentTransaction } from "./asset-assignment-transaction.entity";
import { AssetAssignment } from "./asset-assignment.entity";

@Injectable()
export class AssetAssignmentAdapter {
    public convertDtoToAssetAssignmentEntity(assetsDto: AssetAssignmentDto, isUpdate: boolean = false): AssetAssignment {
        const assetAssignment = new AssetAssignment();

        assetAssignment.assetLocationId = assetsDto.assetLocationId;
        assetAssignment.assetsId = new Assets();
        assetAssignment.assetsId.assetId = assetsDto.assetsId;
        assetAssignment.employeeId = assetsDto.employeeId;
        assetAssignment.checkIn = assetsDto.checkIn;
        assetAssignment.checkOut = assetsDto.checkOut;
        assetAssignment.checkinReason = assetsDto.checkinReason;
        assetAssignment.checkOutReason = assetsDto.checkOutReason;
        assetAssignment.isActive = assetsDto.isActive == undefined ? true : assetsDto.isActive;

        return assetAssignment;
    
    }

    public convertDtoToAssetAssignmentTransactionEntity(assetAssignmentTransDto : AssetAssignmentTransactionDto , isUpdate:boolean = false) : AssetAssignmentTransaction {
        const assetAssignmentTrans = new AssetAssignmentTransaction();
        assetAssignmentTrans.assetAssignmentTransactionId = assetAssignmentTransDto.assetAssignmentTransactionId;
        assetAssignmentTrans.assetAssignment = new AssetAssignment();
        assetAssignmentTrans.assetAssignment.assetAssignmentId = assetAssignmentTransDto.assetAssignmentId;
        assetAssignmentTrans.assetLocationId = assetAssignmentTransDto.assetLocationId;
        assetAssignmentTrans.assetsId = assetAssignmentTransDto.assetsId;
        assetAssignmentTrans.employeeId = assetAssignmentTransDto.employeeId;
        assetAssignmentTrans.checkIn = assetAssignmentTransDto.checkIn;
        assetAssignmentTrans.checkOut  =assetAssignmentTransDto.checkOut;
        assetAssignmentTrans.checkinReason = assetAssignmentTransDto.checkinReason;
        assetAssignmentTrans.checkOutReason = assetAssignmentTransDto.checkOutReason;
        assetAssignmentTrans.status = assetAssignmentTransDto.status;
       
        return assetAssignmentTrans;
    }

    public convertEntityToDto(assignment:AssetAssignment) : AssetAssignmentDto{
        const assignmentDto = new AssetAssignmentDto;
        assignmentDto.assetAssignmentId = assignment.assetAssignmentId;
        assignmentDto.assetLocationId = assignment.assetLocationId;
        assignmentDto.checkIn = assignment.checkIn;
        assignmentDto.checkOut = assignment.checkOut;
        assignmentDto.createdAt = assignment.createdAt;
        assignmentDto.createdUser = assignment.createdUser;
        assignmentDto.employeeId = assignment.employeeId;
        assignmentDto.checkinReason= assignment.checkinReason;
        assignmentDto.checkOutReason = assignment.checkOutReason;
        assignmentDto.isActive = assignment.isActive;
        assignmentDto.updatedAt = assignment.updatedAt;
        assignmentDto.updatedUser = assignment.updatedUser;
        assignmentDto.versionFlag = assignment.versionFlag;
        return assignmentDto;
        
    }

    public convertEntityToTransDto(assignment:AssetAssignmentTransaction) : AssetAssignmentTransactionDto{
        const assignmentDto = new AssetAssignmentTransactionDto;
        // assignmentDto.assetAssignmentId = new AssetAssignment();

        assignmentDto.assetAssignmentTransactionId = assignment.assetAssignmentTransactionId;
        assignmentDto.assetAssignmentId = assignment?.assetAssignment?.assetsId?.assetId;
        assignmentDto.assetName = assignment?.assetAssignment?.assetsId?.assetsName;
        assignmentDto.assetLocationId = assignment.assetLocationId;
        assignmentDto.assetsId = assignment.assetsId
        assignmentDto.checkIn = assignment.checkIn;
        assignmentDto.checkOut = assignment.checkOut;
        assignmentDto.checkinReason = assignment.checkinReason;
        assignmentDto.checkOutReason = assignment.checkOutReason;
        assignmentDto.createdAt = assignment.createdAt;
        assignmentDto.createdUser = assignment.createdUser;
        assignmentDto.employeeId = assignment.employeeId;
        assignmentDto.isActive = assignment.isActive;
        assignmentDto.updatedAt = assignment.updatedAt;
        assignmentDto.updatedUser = assignment.updatedUser;
        assignmentDto.versionFlag = assignment.versionFlag;
        assignmentDto.status = assignment.status;
        return assignmentDto;
        
    }
}